import React from "react";

const SupportDirections = (props) => {
  const code = props.code ? props.code.toUpperCase() : "";

  const getMessage = (code) => {
    if (code === "POLICY_DENIED") {
      return (
        <>
          If you feel this site has been mis-categorized you can open a ticket
        </>
      );
    } else if (code === "GEOIP_DENIED") {
      return (
        <>
          If you feel this site needs to be accessible for business-purposes you
          can open a ticket
        </>
      );
    } else if (code === "TCP_ERROR") {
      return (
        <>
          If you still cannot reach your website <em>after</em> you've tried one
          or more of the steps above, you can open a ticket
        </>
      );
    } else {
      return (
        <>
          If you feel this site needs to be accessible for business-purposes you
          can open a ticket
        </>
      );
    }
  };

  return <span className="support-directions">{getMessage(code)}</span>;
};

export default SupportDirections;
